/* eslint-disable no-trailing-spaces,@typescript-eslint/semi */
import axios from 'axios'
import requests from './httpService'

let cancelToken: any

const getSessionToken = (): string => {
  if (typeof window === 'undefined') {
    return ''
  }
  try {
    const rawUserInfo = localStorage.getItem('userInfo')
    if (rawUserInfo == null || rawUserInfo.trim() === '') {
      return ''
    }
    const parsed = JSON.parse(rawUserInfo) as { token?: string }
    return typeof parsed?.token === 'string' ? parsed.token : ''
  } catch {
    return ''
  }
}

const InstitutionUserService = {
  async InstitutionUserLogin(body: unknown) {
    return await requests.post('/auth/login', body)
  },

  async VerifyOTP(body: unknown) {
    return await requests.post('/auth/verify-otp', body)
  },

  async CreateInstitution(body: unknown) {
    return await requests.post('/institution/create', body)
  },
  async SendRefundRequest(body: unknown) {
    return await requests.post('/add-refund-request', body)
  },
  async TrackRecords(body: unknown) {
    // Public refund-link flows are unauthenticated by design.
    // Skip audit API call when there is no active token to avoid 401 noise.
    if (getSessionToken() === '') {
      return { status: 204, message: 'Skipped audit log submission: no authenticated session.' }
    }
    return await requests.post('/audit/track-audit-logs', body)
  },
  async SendRefundLink(body: unknown) {
    return await requests.post('/check-and-send-refund-request-link', body)
  },

  async getRefundRequestId(params: Record<string, unknown>) {
    return await requests.get('/refund/get-refund-request-last-inserted-data', { params });
  },

  async getBailiffRefundRequestId(params: Record<string, unknown>) {
    return await requests.get('/bailiff/get-refund-request-last-inserted-data', { params });
  },

  async getBailiffDataByTransactionReference(body: unknown) {
    return await requests.post('/bailiff/get-data-by-transaction-reference', body);
  },

  async getSignedBailiffAttachmentUrl(fileName: string) {
    return await requests.get(`/bailiff/refund-attachments/${encodeURIComponent(fileName)}/signed-url`)
  },

  async getBailiffRefundRequestforLastInserted(params: Record<string, unknown>) {
    return await requests.get('/bailiff/get-bailiff-refund-request-for-last-inserted', { params });
  },

  async getUserRoles() {
    return await requests.get('/userRoles/view-roles')
  },

  async CreateUsersAccount(body: unknown) {
    return await requests.post('/auth/register', body)
  },
  async CreateRolesAndPermissions(body: unknown) {
    return await requests.post('/auth/create-roles-permission', body)
  },

  async getBKBidderDetails(body: any) {
    const bidder_data = await requests.post('/auth/proxy/bk-bidder', body)
    return bidder_data
  },

  async getBKAuctionDetails(body: unknown) {
    const auction_data = await requests.post('/auth/proxy/bk-auction', body)
    return auction_data
  },

  async CreateBidSecurity(body: unknown) {
    return await requests.post('/bid-security/upload', body, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  },

  async GetBidSecurityList(
    limit: number,
    page: number,
    search?: string,
    status?: string,
    property_id?: string,
    payer_code?: string
  ) {
    let url = `/bidders-bids/view-all?limit=${limit}&page=${page}`
    // eslint-disable-next-line
    search ? (url = url + `&search=${search}`) : ''
    // eslint-disable-next-line
    status ? (url = url + `&status=${status}`) : ''
    // eslint-disable-next-line
    property_id ? (url = url + `&property_id=${property_id}`) : ''
    // eslint-disable-next-line
    payer_code ? (url = url + `&payer_code=${payer_code}`) : ''
    // eslint-disable-next-line
    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    return await requests.get(url, { cancelToken: cancelToken.token })
  },

  async viewBidSecuritiesAndPaymentReport(
    limit: number,
    page: number,
    from?: string,
    to?: string
  ) {
    let url = `/bid-security/view-bid-securities-report?limit=${limit}&page=${page}`
    // eslint-disable-next-line

    if (from != null) {
      url += `&from=${from}`;
    }

    if (to != null) {
      url += `&to=${to}`;
    }

    // Check if there are any previous pending requests
    if (cancelToken !== undefined) {
      cancelToken.cancel('Operation canceled due to new request.');
    }

    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source();

    // Make the GET request with the constructed URL
    return await requests.get(url, { cancelToken: cancelToken.token });
  },

  async viewBidSecuritiesAndPaymentList(
    limit: number,
    page: number,
    search?: string,
    status?: string,
    property_id?: string,
    payer_code?: string
  ) {
    let url = `/bid-security/view-bid-securities?limit=${limit}&page=${page}`
    // eslint-disable-next-line
    search ? (url = url + `&search=${search}`) : ''
    // eslint-disable-next-line
    status ? (url = url + `&status=${status}`) : ''
    // eslint-disable-next-line
    property_id ? (url = url + `&property_id=${property_id}`) : ''
    // eslint-disable-next-line
    payer_code ? (url = url + `&payer_code=${payer_code}`) : ''
    // eslint-disable-next-line
    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    return await requests.get(url, { cancelToken: cancelToken.token })
  },

  async viewCertifiedCheck(
    limit: number,
    page: number,
    search?: string,
    status?: string,
    property_id?: string
  ) {
    let url = `/bid-security/view-certified-check?limit=${limit}&page=${page}`
    // eslint-disable-next-line
    search ? (url = url + `&search=${search}`) : ''
    // eslint-disable-next-line
    status ? (url = url + `&status=${status}`) : ''
    // eslint-disable-next-line
    property_id ? (url = url + `&property_id=${property_id}`) : ''
    // eslint-disable-next-line
    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    return await requests.get(url, { cancelToken: cancelToken.token })
  },

  async viewDigitalPayments(
    limit: number,
    page: number,
    search?: string,
    status?: string,
    property_id?: string
  ) {
    let url = `/bid-security/view-digital-payments?limit=${limit}&page=${page}`
    // eslint-disable-next-line
    search ? (url = url + `&search=${search}`) : ''
    // eslint-disable-next-line
    status ? (url = url + `&status=${status}`) : ''
    // eslint-disable-next-line
    property_id ? (url = url + `&property_id=${property_id}`) : ''
    // eslint-disable-next-line
    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    return await requests.get(url, { cancelToken: cancelToken.token })
  },

  async viewBidGuarantee(
    limit: number,
    page: number,
    search?: string,
    status?: string,
    property_id?: string
  ) {
    let url = `/bid-security/view-bid-guarantee?limit=${limit}&page=${page}`
    // eslint-disable-next-line
    search ? (url = url + `&search=${search}`) : ''
    // eslint-disable-next-line
    status ? (url = url + `&status=${status}`) : ''
    // eslint-disable-next-line
    property_id ? (url = url + `&property_id=${property_id}`) : ''
    // eslint-disable-next-line
    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    return await requests.get(url, { cancelToken: cancelToken.token })
  },

  async viewEligibleForRefund(
    limit: number,
    page: number,
    search?: string,
    status?: string,
    property_id?: string
  ) {
    let url = `/bid-security/view-eligible-bidders-for-refund?limit=${limit}&page=${page}`
    // eslint-disable-next-line
    search ? (url = url + `&search=${search}`) : ''
    // eslint-disable-next-line
    status ? (url = url + `&status=${status}`) : ''
    // eslint-disable-next-line
    property_id ? (url = url + `&property_id=${property_id}`) : ''
    // eslint-disable-next-line
    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    return await requests.get(url, { cancelToken: cancelToken.token })
  },

  async GetBidSecurityListInstitutions(
    limit: number,
    page: number,
    search?: string,
    status?: string,
    property_id?: string
  ) {
    let url = `/bid-security/view-docs?limit=${limit}&page=${page}`
    // eslint-disable-next-line
    search ? (url = url + `&search=${search}`) : ''
    // eslint-disable-next-line
    status ? (url = url + `&status=${status}`) : ''
    // eslint-disable-next-line
    property_id ? (url = url + `&property_id=${property_id}`) : ''
    // eslint-disable-next-line
    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    return await requests.get(url, { cancelToken: cancelToken.token })
  },

  async EditBidSecurity(bsId: string, body: unknown) {
    return await requests.put('/bid-security/edit/' + bsId, body, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  },

  async getInstitutionList(
    limit: number,
    page: number,
    search?: string,
    type?: string,
    from?: string,
    to?: string
  ) {
    let url = `/institution/view-all?limit=${limit}&page=${page}`
    // eslint-disable-next-line
    search ? (url = url + `&search=${search}`) : ''
    // eslint-disable-next-line
    type ? (url = url + `&type=${type}`) : ''
    // eslint-disable-next-line
    from ? (url = url + `&from=${from}`) : ''
    // eslint-disable-next-line
    to ? (url = url + `&to=${to}`) : ''

    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    return await requests.get(url, { cancelToken: cancelToken.token })
  },

  async EditInstitution(institurionId: string, body: unknown) {
    return await requests.put('/institution/edit/' + institurionId, body)
  },

  async EditProfile(body: unknown) {
    return await requests.put('/auth/update-profile', body)
  },

  async changeStatus(body: unknown) {
    return await requests.post('/auth/change-status', body)
  },

  async changeStatusAndRole(body: unknown) {
    return await requests.post('/auth/change-status-and-role', body)
  },

  async getUserAccountsList(
    limit: number,
    page: number,
    search?: string,
    role?: string,
    from?: string,
    to?: string
  ) {
    let url = `/auth/view-accounts?limit=${limit}&page=${page}`
    // eslint-disable-next-line
    search ? (url = url + `&search=${search}`) : ''
    // eslint-disable-next-line
    role ? (url = url + `&role=${role}`) : ''
    // eslint-disable-next-line
    from ? (url = url + `&from=${from}`) : ''
    // eslint-disable-next-line
    to ? (url = url + `&to=${to}`) : ''
    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    return await requests.get(url, { cancelToken: cancelToken.token })
  },

  async getBidderList(limit: number, page: number, search?: string, from?: string, to?: string) {
    let url = `/bidders-bids/bidders?limit=${limit}&page=${page}`
    // eslint-disable-next-line
    search ? (url = url + `&search=${search}`) : ''
    // eslint-disable-next-line
    from ? (url = url + `&from=${from}`) : ''
    // eslint-disable-next-line
    to ? (url = url + `&to=${to}`) : ''
    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    return await requests.get(url, { cancelToken: cancelToken.token })
  },

  async updateBidderInformation(
    bidderId: string,
    body: {
      email: string
      phone_number: string
      nid: string
    }
  ) {
    return await requests.put(`/bidders-bids/bidders/${bidderId}`, body)
  },

  async getPayemntsList(limit: number, page: number, search?: string, from?: string, to?: string) {
    let url = `/payment/view?limit=${limit}&page=${page}`
    // eslint-disable-next-line
    search ? (url = url + `&search=${search}`) : ''
    // eslint-disable-next-line
    from ? (url = url + `&from=${from}`) : ''
    // eslint-disable-next-line
    to ? (url = url + `&to=${to}`) : ''
    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    return await requests.get(url, { cancelToken: cancelToken.token })
  },

  async DeleteBidSecurityById(id: string) {
    return await requests.delete('/bid-security/' + id + '/delete')
  },

  async updateRefundRequestStatus(payload: {
    RefundRequests: Array<{ transaction_reference: string }>
  }): Promise<any> {
    try {
      const response = await requests.put('/refund/update-refund-request-status', payload)
      return response.data
    } catch (error) {
      // Handle error appropriately
      throw new Error('Failed to update refund request status.')
    }
  },

  async editRefundRequestStatusMessage(payload: {
    RefundRequests: Array<{ transaction_reference: string }>
    status: string
    reason?: string
  }): Promise<any> {
    try {
      const response = await requests.put('/refund/edit-refund-request-status_message', payload)
      return response.data
    } catch (error) {
      // Handle error appropriately
      throw new Error('Failed to update refund request status.')
    }
  },

  async approveAndInitiateRefunds(payload: {
    transactionReferences: string[]
    reason?: string
  }): Promise<any> {
    try {
      const response = await requests.put('/refund/approve-and-initiate', payload)
      return response.data
    } catch (error) {
      throw new Error('Failed to approve and initiate refunds.')
    }
  },

  async approveAndInitiateBailiffRefunds(payload: {
    transactionReferences: string[]
    reason?: string
  }): Promise<any> {
    try {
      const response = await requests.put('/bailiff/approve-and-initiate', payload)
      return response.data
    } catch (error) {
      throw new Error('Failed to approve and initiate bailiff refunds.')
    }
  },

  async editBailiffRefundRequestStatusMessage(payload: {
    BailiffRefundRequest: Array<{
      bailiff_refund_request_id?: string
      transaction_reference: string
      phone_number?: string
      bidder_phone_number?: string
      bailiff_phone_number?: string
    }>
    status: string
    reason?: string
  }): Promise<any> {
    try {
      const response = await requests.put('/bailiff/edit-bailiff-refund-request-status-message', payload)
      return response.data
    } catch (error) {
      // Handle error appropriately
      throw new Error('Failed to update refund request status.')
    }
  },

  async updateBailiffRefundRequestStatus(payload: {
    BailiffRefundRequests: Array<{
      transaction_reference: string
      created_by: string
      bailiff_phone_number?: string
    }>
  }): Promise<any> {
    try {
      const response = await requests.put('/bailiff/update-bailiff-refund-request-status', payload)
      return response.data
    } catch (error) {
      // eslint-disable-next-line max-len
      throw new Error('Failed to update refund request status.')
    }
  },

  async TriggerPayment(body: unknown, token: string) {
    return await requests.post('/bid-security/trigger-payment', body, {
      headers: {
        // eslint-disable-next-line quote-props
        Authorization: token
      }
    })
  },

  async TriggerRefundRequest(body: unknown, token: string) {
    return await requests.post('/refund/add-refund-request', body, {
      headers: {
        Authorization: token
      }
    })
  },

  async TriggerRefundRequestNoOtp(body: unknown, token: string) {
    return await requests.post('/refund/add-refund-request-no-otp', body, {
      headers: {
        Authorization: token
      }
    })
  },

  async TriggerUpdateRefundRequestForBidders(body: unknown, token: string) {
    return await requests.put('/refund/update-refund-request-for-bidders', body, {
      headers: {
        Authorization: token
      }
    })
  },

  async SendRefundRequestLink(body: unknown, token: string) {
    return await requests.post('/refund/check-and-send-refund-request-link', body, {
      headers: {
        Authorization: token
      }
    })
  },

  async SendBailiffRefundRequestLink(body: unknown, token: string) {
    return await requests.post('/bailiff/check-and-send-refund-request-link', body, {
      headers: {
        Authorization: token
      }
    })
  },

  async UpdateToPublicTreasury(body: unknown, token: string) {
    return await requests.post('/refund/update-to-public-treasury', body, {
      headers: {
        Authorization: token
      }
    })
  },

  async BailiffTriggerRefundRequest(body: unknown, token: string) {
    return await requests.post('/bailiff/send_bailiff-refund-request', body, {
      headers: {
        Authorization: token,
        'content-type': 'multipart/form-data'
      }
    })
  },

  async updateBailiffRefundRequest(formData: FormData) {
    return await requests.patch(
      '/bailiff/update_bailiff_refund_request',
      formData
    );
  },

  async viewRefundStatsByRefundStartDate(fromDate: string, toDate: string, token: string) {
    try {
      const params: Record<string, string> = {}
      if (fromDate !== undefined && fromDate !== null && fromDate.trim() !== '') {
        params.fromDate = fromDate
      }
      if (toDate !== undefined && toDate !== null && toDate.trim() !== '') {
        params.toDate = toDate
      }

      const response = await requests.get('/statistics/view-refund-stats-by-refund-start-date', {
        params,
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching refund stats:', error);
      throw error;
    }
  },

  async viewRefundStatsByDate(queryParams: { fromDate?: string, toDate?: string }, token: any) {
    try {
      const queryString = new URLSearchParams(queryParams).toString()

      // Make the GET request
      const response = await requests.get(`/statistics/view-refund-stats-by-date?${queryString}`, {
        headers: {
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          Authorization: `Bearer ${token}`
        }
      })

      return response
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching refund stats:', error)
      throw error
    }
  },

  async FetchToken() {
    const res = await requests.post('/auth/service-token', {})

    return res.token
  },

  async GetPayment(bill_id: string, token: string) {
    const res = await requests.get(`/payment/one/${bill_id}`, {
      headers: {
        // eslint-disable-next-line quote-props
        Authorization: token
      }
    })

    return res.data
  },

  async SearchWithParameters(
    limit: number,
    page: number,
    from?: string,
    to?: string,
    status?: string
  ) {
    const params: Record<string, any> = { limit, page };

    // Add from, to, and status to the params if they exist
    if (from != null) params.from = from;
    if (to != null) params.to = to;
    if (status != null) params.status = status;

    // Cancel previous request if any
    if (typeof cancelToken !== 'undefined') {
      cancelToken.cancel('Operation canceled due to new request.');
    }
    cancelToken = axios.CancelToken.source();

    // Send GET request to the backend
    return await requests.get('/refund/search-all-refund-request-with-parameters', {
      params,
      cancelToken: cancelToken.token
    });
  },

  // eslint-disable-next-line max-len
  async GetRefundRequestList(
    limit: number,
    page: number,
    search?: string,
    from?: string,
    to?: string,
    status?: string
  ) {
    let url = `/refund/view-all-refund-request?limit=${limit}&page=${page}`
    // eslint-disable-next-line
    search ? (url = url + `&search=${search}`) : ''
    // eslint-disable-next-line
    from ? (url = url + `&from=${from}`) : ''
    // eslint-disable-next-line
    to ? (url = url + `&to=${to}`) : ''
    // eslint-disable-next-line
    status ? (url = url + `&status=${status}`) : ''
    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    return await requests.get(url, { cancelToken: cancelToken.token })
  },

  async GetNewBailiffRefundRequestList(
    limit: number,
    page: number,
    search?: string,
    from?: string,
    to?: string
  ) {
    // eslint-disable-next-line max-len
    let url = `/bailiff/view-new-bailiff-refund-requests?limit=${limit}&page=${page}`
    // eslint-disable-next-line
    search ? (url = url + `&search=${search}`) : ''
    // eslint-disable-next-line
    from ? (url = url + `&from=${from}`) : ''
    // eslint-disable-next-line
    to ? (url = url + `&to=${to}`) : ''
    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    return await requests.get(url, { cancelToken: cancelToken.token })
  },

  // eslint-disable-next-line max-len
  async GetBailiffRefundRequestList(
    limit: number,
    page: number,
    from?: string,
    to?: string,
    status?: string
  ) {
    const params: Record<string, any> = { limit, page };

    // Add from, to, and status to the params if they exist
    if (from != null) params.from = from;
    if (to != null) params.to = to;
    if (status != null) params.status = status;

    // Cancel previous request if any
    if (typeof cancelToken !== 'undefined') {
      cancelToken.cancel('Operation canceled due to new request.');
    }
    cancelToken = axios.CancelToken.source();

    // Send GET request to the backend
    return await requests.get('/bailiff/search-all-bailiff-refund-request-with-parameters', {
      params,
      cancelToken: cancelToken.token
    });
  },

  // eslint-disable-next-line max-len
  async GetRefundRequestListByStatus(
    limit: number,
    page: number,
    search?: string,
    from?: string,
    to?: string
  ) {
    let url = `/refund/view-all-refund-request-by-status?limit=${limit}&page=${page}`
    // eslint-disable-next-line
    search ? (url = url + `&search=${search}`) : ''
    // eslint-disable-next-line
    from ? (url = url + `&from=${from}`) : ''
    // eslint-disable-next-line
    to ? (url = url + `&to=${to}`) : ''
    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    return await requests.get(url, { cancelToken: cancelToken.token })
  },

  // eslint-disable-next-line max-len
  async GetPendingRefundRequestListByStatusFromBailiffs(
    limit: number,
    page: number,
    search?: string,
    from?: string,
    to?: string,
    linkFilter?: 'with_link' | 'without_link',
    status?: string
  ) {
    let url = `/bailiff/view-all-pending-refund-request-by-status-from-bailiff?limit=${limit}&page=${page}`
    if (search != null && String(search).trim() !== '') {
      url = `${url}&search=${encodeURIComponent(String(search).trim())}`
    }
    // eslint-disable-next-line
    from ? (url = url + `&from=${from}`) : ''
    // eslint-disable-next-line
    to ? (url = url + `&to=${to}`) : ''
    // eslint-disable-next-line
    status ? (url = url + `&status=${status}`) : ''
    const linkFilterParam =
      linkFilter === 'with_link' || linkFilter === 'without_link' ? linkFilter : 'with_link'
    url = `${url}&link_filter=${linkFilterParam}`
    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    return await requests.get(url, { cancelToken: cancelToken.token })
  },

  async GetPendingRefundRequestListByStatusFromBidders(
    limit: number,
    page: number,
    search?: string,
    from?: string,
    to?: string,
    linkFilter?: 'with_link' | 'without_link',
    status?: string
  ) {
    let url = `/refund/view-all-pending-refund-request-by-status?limit=${limit}&page=${page}`
    if (search != null && String(search).trim() !== '') {
      url = `${url}&search=${encodeURIComponent(String(search).trim())}`
    }
    // eslint-disable-next-line
    from ? (url = url + `&from=${from}`) : ''
    // eslint-disable-next-line
    to ? (url = url + `&to=${to}`) : ''
    // eslint-disable-next-line
    status ? (url = url + `&status=${status}`) : ''
    const linkFilterParam =
      linkFilter === 'with_link' || linkFilter === 'without_link' ? linkFilter : 'with_link'
    url = `${url}&link_filter=${linkFilterParam}`
    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    return await requests.get(url, { cancelToken: cancelToken.token })
  },

  async SendPendingBidderRefundReminderEmail(body: {
    refund_request_id: string
    use_with_link_reminder_copy?: boolean
    use_no_link_reminder_copy?: boolean
  }) {
    return await requests.post('/refund/send-pending-refund-reminder-email', body)
  },

  async SendPendingBidderRefundReminderSms(body: {
    refund_request_id: string
    use_with_link_reminder_copy?: boolean
    use_no_link_reminder_copy?: boolean
  }) {
    return await requests.post('/refund/send-pending-refund-reminder-sms', body)
  },

  async SendPendingBailiffRefundReminderEmail(body: { bailiff_refund_request_id: string }) {
    return await requests.post('/bailiff/send-pending-bailiff-refund-reminder-email', body)
  },

  async SendPendingBailiffRefundReminderSms(body: { bailiff_refund_request_id: string }) {
    return await requests.post('/bailiff/send-pending-bailiff-refund-reminder-sms', body)
  },

  async viewAllNotRequestedRefund(
    limit: number,
    page: number,
    search?: string,
    from?: string,
    to?: string
  ) {
    let url = `/refund/view-all-not-requested-refund?limit=${limit}&page=${page}`
    // eslint-disable-next-line
    search ? (url = url + `&search=${search}`) : ''
    // eslint-disable-next-line
    from ? (url = url + `&from=${from}`) : ''
    // eslint-disable-next-line
    to ? (url = url + `&to=${to}`) : ''
    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    return await requests.get(url, { cancelToken: cancelToken.token })
  },

  async ViewUpdatedToPublicTreasury(
    limit: number,
    page: number,
    search?: string,
    from?: string,
    to?: string
  ) {
    let url = `/refund/view-all-updated-to-public-treasury?limit=${limit}&page=${page}`
    // eslint-disable-next-line
    search ? (url = url + `&search=${search}`) : ''
    // eslint-disable-next-line
    from ? (url = url + `&from=${from}`) : ''
    // eslint-disable-next-line
    to ? (url = url + `&to=${to}`) : ''
    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    return await requests.get(url, { cancelToken: cancelToken.token })
  },

  // eslint-disable-next-line max-len
  async GetRefundRequestListByTransfer(
    limit: number,
    page: number,
    search?: string,
    from?: string,
    to?: string
  ) {
    let url = `/refund/view-all-bidders-refund-request-by-transfer?limit=${limit}&page=${page}`
    // eslint-disable-next-line
    search ? (url = url + `&search=${search}`) : ''
    // eslint-disable-next-line
    from ? (url = url + `&from=${from}`) : ''
    // eslint-disable-next-line
    to ? (url = url + `&to=${to}`) : ''
    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    return await requests.get(url, { cancelToken: cancelToken.token })
  },

  // eslint-disable-next-line max-len
  async GetBailiffsRefundRequestListByTransfer(
    limit: number,
    page: number,
    search?: string,
    from?: string,
    to?: string
  ) {
    let url = `/bailiff/view-all-bailiff-refund-request-by-transfer?limit=${limit}&page=${page}`
    // eslint-disable-next-line
    search ? (url = url + `&search=${search}`) : ''
    // eslint-disable-next-line
    from ? (url = url + `&from=${from}`) : ''
    // eslint-disable-next-line
    to ? (url = url + `&to=${to}`) : ''
    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    return await requests.get(url, { cancelToken: cancelToken.token })
  },

  // eslint-disable-next-line max-len
  async GetBailiffRefundRequestListByStatus(
    limit: number,
    page: number,
    search?: string,
    from?: string,
    to?: string
  ) {
    let url = `/bailiff/view-all-bailiff-refund-request-by-status?limit=${limit}&page=${page}`
    // eslint-disable-next-line
    search ? (url = url + `&search=${search}`) : ''
    // eslint-disable-next-line
    from ? (url = url + `&from=${from}`) : ''
    // eslint-disable-next-line
    to ? (url = url + `&to=${to}`) : ''
    // Check if there are any previous pending requests
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    // Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()
    return await requests.get(url, { cancelToken: cancelToken.token })
  },

  async ChangePassword(body: {
    old_password: string
    new_password: string
    confirm_password: string
  }) {
    return await requests.post('/auth/change-password', body)
  },

  async Logout() {
    return await requests.post('/auth/logout', {})
  },

  async SAdminStats() {
    return await requests.get('/statistics/sadmin', {})
  },

  async MFinanceStats() {
    return await requests.get('/statistics/mfinance', {})
  },

  async CountNumberOfNewRequest() {
    return await requests.get('/refund/count-refund-request', {})
  },

  async MFinanceRefundStats() {
    return await requests.get('/statistics/mFinanceRefund', {})
  },

  async RefundRequestStats() {
    return await requests.get('/statistics/refundStats', {})
  },

  async bailiffRefundRequestStats() {
    return await requests.get('/statistics/mBailiffRefundStat', {})
  },

  async GetPendingRefundRequestsByMonth(months = 12) {
    const m = Number.isFinite(months) && months > 0 ? Math.min(36, Math.floor(months)) : 12
    return await requests.get(`/statistics/pending-refund-requests-by-month?months=${m}`)
  },

  async InstitutionStats() {
    return await requests.get('/statistics/institution', {})
  },

  async GetUsageBS(ref_number: string) {
    return await requests.get(`/bid-security/used/${ref_number}`)
  },
  async GetBillData(bill_id: string) {
    return await requests.get(`/payment/bid-security/bill/${bill_id}`)
  },
  async GetBidsDetailsForRefund(ref_number: string) {
    return await requests.get(`/bid-security/validate/${ref_number}`)
  },
  async resetPassword(body: { email: string }): Promise<any> {
    return await requests.post('/auth/reset-password', body)
  },

  async viewBailiffRefundRequestByReferenceNumber (ref_number: string | undefined) {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    return await requests.get(`/bailiff/view-bailiff-refund-request-by-reference-number/${ref_number}`)
  },
  async createOtpCode(body: unknown) {
    // Create OTP code for refund request
    // Note: The endpoint /refund/validate-otp is used to create/generate OTP codes
    return await requests.post('/refund/validate-otp', body)
  },
  async validateRefundRequestByRefNumberAndStatus(body: unknown) {
    return await requests.post(
      '/refund/validate-refund-request-by-reference-number-and-status',
      body
    )
  },
  async validateRefundRequest(body: unknown) {
    return await requests.post('/refund/validate-refund-request', body)
  },

  async validateBailiffRefundRequest(body: unknown) {
    return await requests.post('/bailiff/validate-bailiff-refund-request', body)
  },

  async bailiffCreateOtpCode(body: unknown) {
    return await requests.post('/bailiff/bailiff_validate_otp', body)
  },
  async verifyOtpToSendRequest(body: unknown) {
    return await requests.post('/refund/verify-otp', body)
  },
  async verifyOtpForRequestedRefund(body: unknown) {
    return await requests.post('/refund/verify-otp-for-requested-refund', body)
  },
  async bailiffVerifyOtpToSendRequest(body: unknown) {
    return await requests.post('/bailiff/bailiff_verify-otp', body)
  },
  async getLastInsertedData() {
    return await requests.get('/refund/get-data')
  },

  async getBailiffLastInsertedData() {
    return await requests.get('/bailiff/get_last_inserted_data')
  },

  async RefundRequestConfirmation(body: unknown) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    return await requests.put('/refund/refund-request-confirmation', body)
  },

  async BailiffRefundRequestConfirmation(body: unknown) {
    return await requests.put('/bailiff/bailiff_refund-request-confirmation', body)
  },

  async loadBidsDetailsForRefund(ref_number: string) {
    return await requests.get(`/refund/refund_request/bidSecurityReference/${ref_number}`)
  },

  async loadBiddersAuctionDetails(ref_number: string) {
    return await requests.get(`/refund/refund_request/requestBidSecurityFees/${ref_number}`)
  },

  async loadWinnerBidderDetailsForRefund(ref_number: string) {
    return await requests.get(`bailiff/bailiff_refund_request/bidSecurityReference/${ref_number}`)
  },

  async getBidderDetails(body: { property_id: string, nid: string, phone_number: string }) {
    return await requests.post('/refund/validate-bidder', body)
  },

  async validateRequestWhenOtpExpired(body: unknown) {
    return await requests.post('/refund/validate-request-when-otp-expired', body)
  },

  async loadRefundRequestId(body: unknown) {
    return await requests.post('/refund/get-data-by-transaction-reference-and-status', body);
  },
  async loadBailiffRefundRequestId(body: unknown) {
    // eslint-disable-next-line max-len
    return await requests.post('/bailiff/get-bailiff-data-by-transaction-reference-and-status', body);
  },

  async bailiffValidateRequestWhenOtpExpired(body: unknown) {
    return await requests.post('/bailiff/bailiff-validate-request-when-otp-expired', body)
  },

  // https://cyamunara.gov.rw/oa-de/validate-bailiff
  // http://10.8.124.173:8801/rwa-iecms-oa-de/validate-bailiff
  // https://iecms.gov.rw/rwaiecmsservice/v1/rwa-iecms/validate-bailiff

  async validateBailiffDetailsOnAuction(prpParam: any, ref_number: any) {
    return await requests.post('/auth/proxy/validate-bailiff', {
      prp: prpParam,
      bidSecurityReferenceNumber: ref_number
    })
  },

  async validateBidderForRefund(ref_number: any) {
    return await requests.post('/auth/proxy/validate-bidder', {
      bidSecurityReferenceNumber: ref_number
    })
  },

  async GetAllRefundRequestsCombined(params: Record<string, unknown>) {
    return await requests.get('/refund/get-all-refund-requests-combined', { params })
  },

  async GetComprehensiveReportData(params: {
    limit?: number
    page?: number
    search?: string
    status?: string
    from?: string
    to?: string
    sort_by?: string
    sort_order?: string
    report_type?: string
  }) {
    // Cancel previous request if any
    if (typeof cancelToken !== 'undefined') {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    cancelToken = axios.CancelToken.source()

    return await requests.get('/refund/get-comprehensive-report-data', {
      params,
      cancelToken: cancelToken.token,
      // Avoid conditional caching (ETag/If-None-Match) returning 304 with empty body,
      // which prevents the reporting table from updating reliably in the browser.
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache'
      }
    })
  },

  async GetBiddersNotRequestedBidSecurityReport(params: {
    limit?: number
    page?: number
    search?: string
    status?: string
    from?: string
    to?: string
    property_id?: string
    payer_code?: string
  }) {
    if (typeof cancelToken !== 'undefined') {
      cancelToken.cancel('Operation canceled due to new request.')
    }
    cancelToken = axios.CancelToken.source()

    return await requests.get('/refund/bidders-not-requested-bid-security-report', {
      params,
      cancelToken: cancelToken.token,
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache'
      }
    })
  },

  async getBidderByNID(nid: string) {
    return await requests.get(`/bidders-bids/bidders/${nid}`)
  },

  async getRefundByTransactionRef(refNumber: string) {
    return await requests.get(`/refund/transaction/${refNumber}`)
  },

  async getAuditLogs(
    limit: number,
    page: number,
    search = '',
    action = '',
    tableName = '',
    from = '',
    to = ''
  ) {
    let url = `/audit/get-all-audit-logs?limit=${limit}&page=${page}`
    if (search !== '') url += `&search=${encodeURIComponent(search)}`
    if (action !== '') url += `&action=${encodeURIComponent(action)}`
    if (tableName !== '') url += `&table_name=${encodeURIComponent(tableName)}`
    if (from !== '') url += `&from=${encodeURIComponent(from)}`
    if (to !== '') url += `&to=${encodeURIComponent(to)}`
    return await requests.get(url)
  },

  async getAuditLogsByRecordId(recordId: string, limit = 10, page = 1) {
    return await requests.get(`/audit/get-audit-logs-by-record/${recordId}?limit=${limit}&page=${page}`)
  },

  async getAuditLogsByRefundRequestId(refundRequestId: string, limit = 10, page = 1) {
    return await requests.get(`/audit/get-audit-logs-by-refund-request/${refundRequestId}?limit=${limit}&page=${page}`)
  },

  async getSuccessRefundsReport(params: {
    limit?: number
    page?: number
    search?: string
    status?: string
    from?: string
    to?: string
    sort_by?: string
    sort_order?: string
  }) {
    return await requests.get('/refund/success-report', { params })
  },

  async getSystemSettingByKey(settingKey: string) {
    return await requests.get(`/system-settings/key/${settingKey}`)
  },

  async updateSystemSettingByKey(
    settingKey: string,
    payload: { setting_value: string, updated_by?: string }
  ) {
    return await requests.put(`/system-settings/key/${settingKey}`, payload)
  },

  async createSystemSetting(payload: {
    setting_key: string
    setting_value: string
    setting_category: string
    setting_description?: string
    data_type?: string
    created_by: string
  }) {
    return await requests.post('/system-settings', payload)
  }
}

export default InstitutionUserService
